import { useTableRowGroup } from '@react-aria/table';
import React from 'react';

import { VariantProps } from 'class-variance-authority';
import { rowGroupClassNames } from './styles';

interface Props {
    as?: 'thead' | 'tbody';
    children?: React.ReactNode;
}

type NativeAttrs = Omit<React.HTMLAttributes<unknown>, keyof Props>;

export type TableRowGroupProps = Props & VariantProps<typeof rowGroupClassNames> & NativeAttrs;

// Forward the ref so callers (e.g. the infinite-scroll body) can measure the scroll container.
const TableRowGroup = React.forwardRef<HTMLTableSectionElement, React.PropsWithChildren<TableRowGroupProps>>(
    ({ as = 'thead', children, isInfinityScroll, isFixed, ...props }, ref) => {
        const {
            rowGroupProps
        }: {
            rowGroupProps: Omit<React.HTMLAttributes<unknown>, keyof TableRowGroupProps>;
        } = useTableRowGroup();

        const Element = as;

        return (
            <Element
                ref={ref}
                className={rowGroupClassNames({ className: props.className, isInfinityScroll, isFixed })}
                {...rowGroupProps}
                {...props}
            >
                {children}
            </Element>
        );
    }
);

TableRowGroup.displayName = 'TableRowGroup';

export default TableRowGroup;
